import React from "react";
import { MeterPointType } from "../../api/meters";
import { ElectricityIcon, GasIcon, GenericUtilityIcon } from "../../icons";

interface MeterPointIconProps {
  type: MeterPointType | undefined;
  height?: number;
  width?: number;
  style?: any;
}

export const UtilityIcon: React.FC<MeterPointIconProps> = ({
  type,
  ...props
}) => {
  switch (type) {
    case "MPAN":
      return <ElectricityIcon {...props} />;
    case "MPRN":
      return <GasIcon {...props} />;
    default:
      return <GenericUtilityIcon {...props} />;
  }
};
